if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                    const selectedIds = [];
                    const singleCheckboxes = document.querySelectorAll('._hid_checkbox:checked');
                    singleCheckboxes.forEach((cb) => {
                      if (cb.value) selectedIds.push(cb.value);
                    });
                    const multiCheckboxes = document.querySelectorAll('._hid_checkbox_multi:checked');
                    multiCheckboxes.forEach((cb) => {
                      if (cb.value && cb.value !== '') selectedIds.push(cb.value);
                    });
                    if (selectedIds.length) {
                      addItemsSequential(selectedIds, this.cart);
                    }
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
              const selectedIds = [];
              const singleCheckboxes = document.querySelectorAll('._hid_checkbox:checked');
              singleCheckboxes.forEach((cb) => {
                if (cb.value) selectedIds.push(cb.value);
              });
              const multiCheckboxes = document.querySelectorAll('._hid_checkbox_multi:checked');
              multiCheckboxes.forEach((cb) => {
                if (cb.value && cb.value !== '') selectedIds.push(cb.value);
              });
              if (selectedIds.length) {
                addItemsSequential(selectedIds, this.cart);
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

function addItemToCartForm(id, cartInstance) {
  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];
  const formData = new FormData();
  formData.append('id', id);
  formData.append('quantity', 1);
  if (cartInstance) {
    formData.append('sections', cartInstance.getSectionsToRender().map((section) => section.id));
    formData.append('sections_url', window.location.pathname);
    cartInstance.setActiveElement(document.activeElement);
  }
  config.body = formData;
  const addUrl = typeof routes !== 'undefined' && routes.cart_add_url ? routes.cart_add_url : '/cart/add';
  return fetch(addUrl, config).then((r) => r.json());
}

function addItemsSequential(ids, cartInstance) {
  let chain = Promise.resolve();
  ids.forEach((id) => {
    chain = chain.then(() => {
      return addItemToCartForm(id, cartInstance).then((response) => {
        if (!response.status && cartInstance) {
          CartPerformance.measure("add:paint-updated-sections", () => {
            cartInstance.renderContents(response);
          });
        }
        return response;
      });
    });
  });
  return chain;
}

document.addEventListener('click', (e) => {
  const btn = e.target.closest('.upsell__add');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();
  const container = btn.closest('.parent_cart');
  if (!container) return;
  let variantId = btn.dataset.variantId || null;
  if (!variantId) {
    const select = container.querySelector('._input_selectBox');
    if (select && select.value && select.value !== '-1') {
      variantId = select.value;
    } else {
      return;
    }
  }
  btn.disabled = true;
  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  addItemToCartForm(variantId, cart)
    .then((response) => {
      if (!response.status) {
        if (cart) {
          CartPerformance.measure("add:paint-updated-sections", () => {
            cart.renderContents(response);
          });
        }
      }
    })
    .catch(() => {})
    .finally(() => {
      btn.disabled = false;
    });
});

document.addEventListener('change', (e) => {
  const target = e.target;
  if (!target.classList || !target.classList.contains('_input_selectBox')) return;
  const select = target;
  const container = select.closest('.parent_cart');
  if (!container) return;
  const productId = select.dataset.productId;
  const checkbox = container.querySelector(`#upsell-checkbox-multi-${productId}`);
  if (checkbox) {
    if (select.value && select.value !== '-1') {
      checkbox.disabled = false;
      checkbox.checked = true;
      checkbox.value = select.value;
    } else {
      checkbox.disabled = true;
      checkbox.checked = false;
      checkbox.value = '';
    }
  }
  const selectedOption = select.options[select.selectedIndex];
  const priceData = selectedOption ? selectedOption.getAttribute('price_data') : null;
  if (priceData) {
    const priceElement = container.querySelector('._price_data');
    if (priceElement) {
      priceElement.textContent = priceData;
    }
  }
});
